import { ClipPath, Defs, G, LinearGradient, Path, Rect, Stop, Svg } from '@react-pdf/renderer';

const ReportCoverBackground = () => (
  <Svg width="595" height="842" viewBox="0 0 595 842" fill="none">
    <G clip-path="url(#clip0_7777_118774)">
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 842H595V0H415.426C577.315 98.9884 655.657 533.42 343.563 471.407C213.101 445.485 101.167 373.038 0 478.057V842Z"
        fill="url(#paint0_linear_7777_118774)"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 841.182H595V309.265C566.118 509.456 441.457 499.08 343.563 471.407C216.977 435.63 67.1689 323.011 0 477.231V841.174V841.182Z"
        fill="url(#paint1_linear_7777_118774)"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 841.174H595V389.37C472.232 649.31 151.105 316.254 0 511.083V841.174Z"
        fill="#554688"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M595 841.174H0V262.262C80.4903 432.697 436.218 611.385 595 491.918V841.174Z"
        fill="url(#paint2_linear_7777_118774)"
      />
      <Path
        opacity="0.6"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M595 841.174H0V477.231C27.9898 412.971 70.334 395.053 119.355 398.589C261.577 508.514 479.958 578.466 595 491.918V841.174Z"
        fill="#2A186A"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 841.174H595V491.918C499.874 563.489 334.084 528.034 199.11 451.466C122.719 439.62 51.484 444.7 0 511.083V841.174Z"
        fill="url(#paint3_linear_7777_118774)"
      />
    </G>
    <Defs>
      <LinearGradient id="paint0_linear_7777_118774" x1="552.962" y1="206.94" x2="408.122" y2="464.02">
        <Stop offset="0" stopColor="white" />
        <Stop offset="0.35" stopColor="#F5F7FC" />
        <Stop offset="0.68" stopColor="#DDE2ED" />
        <Stop offset="1" stopColor="#E2E2E3" />
      </LinearGradient>
      <LinearGradient id="paint1_linear_7777_118774" x1="297.5" y1="486.07" x2="297.5" y2="397.135">
        <Stop offset="0" stopColor="#B9C1D4" />
        <Stop offset="1" stopColor="#A7B1C9" />
      </LinearGradient>
      <LinearGradient id="paint2_linear_7777_118774" x1="120.686" y1="339.07" x2="69.5874" y2="244.344">
        <Stop offset="0" stopColor="#9774E6" />
        <Stop offset="1" stopColor="#6430DA" />
      </LinearGradient>
      <LinearGradient id="paint3_linear_7777_118774" x1="394.675" y1="812.154" x2="166.993" y2="470.74">
        <Stop offset="0" stopColor="#2A186A" />
        <Stop offset="1" stopColor="#261660" />
      </LinearGradient>
      <ClipPath id="clip0_7777_118774">
        <Rect width="595" height="842" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default ReportCoverBackground;
